/**
 * @generated SignedSource<<aea227b151d98d2db2d21e248be7c59c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InlineContentDrawerHeaderOverflowFragment$data = {
  readonly content: {
    readonly hasViewerBookmarked: boolean;
    readonly " $fragmentSpreads": FragmentRefs<"BookmarkButtonContentFragment">;
  };
  readonly " $fragmentSpreads": FragmentRefs<"BookmarkButtonContentUsageFragment" | "CopyContentUsageLinkButtonFragment" | "DeleteContentUsageButtonFragment" | "ShareContentUsageByEmailButtonFragment" | "usePermissionsFragment">;
  readonly " $fragmentType": "InlineContentDrawerHeaderOverflowFragment";
};
export type InlineContentDrawerHeaderOverflowFragment$key = {
  readonly " $data"?: InlineContentDrawerHeaderOverflowFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"InlineContentDrawerHeaderOverflowFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InlineContentDrawerHeaderOverflowFragment",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DeleteContentUsageButtonFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "usePermissionsFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CopyContentUsageLinkButtonFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ShareContentUsageByEmailButtonFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BookmarkButtonContentUsageFragment"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Content",
      "kind": "LinkedField",
      "name": "content",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasViewerBookmarked",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "BookmarkButtonContentFragment"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ContentUsage",
  "abstractKey": null
};

(node as any).hash = "a3030fc62a91646e91ac3dc3c34e3e4b";

export default node;
